import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { PageTitle, Panel } from "@/components/studio/common";
import { useAuth } from "@/context/AuthContext";
import { api, formatErr } from "@/lib/api";

const FIELDS = [
  ["success_fee_pct", "Success fee (%)", "number"], ["penale_bypass", "Penale by-pass (€)", "number"], ["tariffa_revoca", "Compenso revoca predefinito (€)", "number"],
  ["callback_hours", "Ore per il ricontatto", "number"], ["studio_nome", "Nome studio", "text"], ["avvocato", "Avvocato titolare", "text"],
  ["ordine", "Ordine di iscrizione", "text"], ["iscrizione", "Numero iscrizione", "text"], ["indirizzo", "Indirizzo sede", "text"],
  ["pec", "PEC", "email"], ["piva", "Partita IVA", "text"], ["telefono", "Telefono (facoltativo)", "text"], ["email_notifiche", "Email notifiche interne", "email"], ["email_ricezione_mandati", "Email ricezione mandati cartacei", "email"],
];

export default function Settings() {
  const { user } = useAuth();
  const ro = user.role !== "admin";
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/settings").then((r) => setS(r.data)); }, []);
  const save = async () => { try { const { data } = await api.put("/admin/settings", s); setS(data); toast.success("Impostazioni salvate"); } catch (e) { toast.error(formatErr(e)); } };
  if (!s) return null;

  return (
    <div data-testid="settings-page">
      <PageTitle title="Impostazioni" sub={ro ? "Sola lettura: solo l'avvocato titolare può modificare" : "Parametri del servizio, del mandato e dati dello studio"}>
        {!ro && <Button data-testid="settings-save-btn" onClick={save} className="bg-navy hover:bg-navy-800">Salva</Button>}
      </PageTitle>
      <Panel title="Esito della verifica pubblica" className="mb-6" testid="settings-result-mode">
        <RadioGroup value={s.result_mode} onValueChange={(v) => setS({ ...s, result_mode: v })} disabled={ro} className="grid md:grid-cols-2 gap-3">
          {[["immediate", "Esito immediato", "Mostra \"risultato trovato / non trovato\" (mai importi né banca)."],
            ["callback", "Sempre \"ti ricontattiamo\"", "Mostra sempre il messaggio di ricontatto; il matching resta visibile solo allo studio."]].map(([v, t, sub]) => (
            <label key={v} className={`flex gap-3 border rounded-lg p-4 cursor-pointer ${s.result_mode === v ? "border-navy bg-slate-50" : "border-slate-200"}`}>
              <RadioGroupItem value={v} data-testid={`settings-mode-${v}`} className="mt-1" />
              <span><span className="block font-semibold text-navy">{t}</span><span className="text-sm text-slate-600">{sub}</span></span>
            </label>
          ))}
        </RadioGroup>
      </Panel>
      <Panel title="Parametri e dati studio" testid="settings-fields">
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
          {FIELDS.map(([k, l, t]) => (
            <div key={k}><Label className="text-xs text-slate-500">{l}</Label>
              <Input data-testid={`settings-${k}`} type={t} disabled={ro} value={s[k] ?? ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} className="mt-1" /></div>
          ))}
        </div>
      </Panel>
    </div>
  );
}
